// extracted by mini-css-extract-plugin
export default {"selectedLink":"DrawerMenu_selectedLink__oeb6A","linkList":"DrawerMenu_linkList__x6yzf"};